import { AxiosInstance } from 'axios'

export type RenameDocumentParams = {
  uuid: string
  label: string
  oldName: string
}

export const renameDocument = async (
  apiClient: AxiosInstance,
  params: RenameDocumentParams
) => {
  const { data } = await apiClient.postForm('/ajax/crunches/rename', {
    label: params.label,
    uuid: params.uuid,
  })
  return data
}
